function n(n){var i;null===(i=window)||void 0===i||null===(i=i.parent)||void 0===i||i.postMessage(JSON.stringify(n),"*")}export{n as broadcastToParent};
//# sourceMappingURL=broadcast2parent.js.map
